import React, { useRef } from 'react';

const BaseStone = ({ texture }) => {
  const mesh = useRef();

  return (
    <mesh
      position={[-1.2, -3, 0]}
      ref={mesh}
      scale={[1, 1, 1]}
    >
      <boxGeometry args={[7, 1, 3.7]} />
      <meshStandardMaterial map={texture} />
    </mesh>
  );
};

export default BaseStone;
